<template>
  <div class="company-info">
    <div class="page-header"><h2><span class="breadcrumb-level">内容运营</span><span class="breadcrumb-sep">/</span><span class="breadcrumb-level breadcrumb-current">企业信息管理</span></h2></div>
    <el-form :model="form" label-width="150px" v-loading="loading">
      <el-card class="info-card">
        <template #header><span>基本信息</span></template>
        <el-form-item label="企业名称">
          <el-input v-model="form.company_name" placeholder="用于宠境酒店页面顶部显示" />
        </el-form-item>
        <el-form-item label="企业介绍">
          <RichTextEditor v-model="form.company_intro" />
          <div class="tip">涉及页面：关于宠境</div>
        </el-form-item>
        <el-form-item label="地址">
          <el-input v-model="form.company_address" placeholder="用于一键导航" />
          <div class="tip">涉及页面：关于宠境、宠境酒店</div>
        </el-form-item>
        <el-form-item label="联系电话">
          <el-input v-model="form.company_phone" placeholder="用于一键拨号" />
          <div class="tip">涉及页面：关于宠境、宠境酒店</div>
        </el-form-item>
        <el-form-item label="服务模式">
          <el-input v-model="form.service_mode" placeholder="用于宠境酒店页面服务模式处显示" />
        </el-form-item>
      </el-card>

      <el-card class="info-card" style="margin-top:20px;">
        <template #header><span>微信二维码</span></template>
        <el-form-item label="二维码图片">
          <Upload v-model="form.wechat_qrcode" :max-count="1" />
          <div class="tip">用于工作犬详情页底部的咨询了解</div>
        </el-form-item>
      </el-card>

      <div style="margin-top:20px;text-align:center;">
        <el-button type="primary" size="large" @click="handleSave" :loading="saving">保存</el-button>
      </div>
    </el-form>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { ElMessage } from 'element-plus';
import RichTextEditor from '../../components/RichTextEditor.vue';
import * as contentApi from '../../api/contentManagement';
import Upload from '../../components/Upload.vue';

const form = ref({
  company_name: '', company_intro: '', company_address: '', company_phone: '',
  service_mode: '', wechat_qrcode: '',
});
const loading = ref(false);
const saving = ref(false);


const fetchData = async () => {
  loading.value = true;
  try {
    const res = await contentApi.getCompanyInfos();
    const data = res.data || {};
    Object.keys(form.value).forEach(key => {
      const info = data[key];
      if (info) form.value[key] = info.value;
    });
  } catch { ElMessage.error('获取企业信息失败'); } finally { loading.value = false; }
};

const handleSave = async () => {
  saving.value = true;
  try {
    await contentApi.updateCompanyInfos(form.value);
    ElMessage.success('保存成功');
  } catch { ElMessage.error('保存失败'); } finally { saving.value = false; }
};

onMounted(fetchData);

</script>

<style scoped>
.info-card { margin-bottom: 0; }
.tip { font-size: 12px; color: #999; margin-top: 4px; }
.upload-img { width: 200px; height: 120px; object-fit: cover; border-radius: 4px; }
.upload-icon { font-size: 28px; color: #8c939d; }
.avatar-uploader { border: 1px dashed #d9d9d9; border-radius: 6px; cursor: pointer; padding: 20px; text-align: center; display: inline-block; }
.avatar-uploader:hover { border-color: #409eff; }
</style>
